// import { LoginService } from './../registration/services/login.service';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnInit,
  AfterViewInit,

} from '@angular/core';
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
// import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
// import { NgxSpinnerService } from 'ngx-spinner';
import {
  NavigationCancel,
  Event,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { Role, RoleParent, StaffRoleNew, User } from '@cradua/domain';
import { AuthFacade } from '@cradua/auth';
import {AuthenticationService} from '../../../../../apps/epims/mrsoftepims/src/app/services/auth.service';
import { GatewayFacade } from './../../../../gateway/src/lib/states/+gateway/gateway.facades';
import { DashboardComponent } from './../../../../dashboard/src/lib/components/dashboard/dashboard.component';
import { GatewayService } from  'libs/gateway/src/lib/services/gateway.service';
import { take } from 'rxjs/operators';


@Component({
  selector: 'dashboardnav',
  templateUrl: './dashboard-nav.component.html',
  styleUrls: ['./dashboard-nav.component.css'],
})
export class DashboardNavComponent implements OnInit,AfterViewInit {

  user: User;
  RoleData: StaffRoleNew[];
  RoleForStaffData: StaffRoleNew[];
  selectedRolesForStaff: StaffRoleNew[] = [];

  roles: RoleParent[] = [];

  rolesForDB: Role[] = [];
  rolesDeleted: Role[] = [];

  rolesExistingInDB: Role[] = [];
  isHome: boolean = true;
  SubscriberName = "";
  StaffName = "";


  @ViewChild(DashboardComponent) dashboard: DashboardComponent;
  //@ViewChildren('sidenav') sc: QueryList<MdSidenav>;


  constructor(
    mediaObserver: MediaObserver,
    //  private _loadingBar: NgxSpinnerService,
    // tslint:disable-next-line: variable-name
    private _router: Router,
    // private loginservice: LoginService,
    // private spinner: NgxSpinnerService,
    // private subscriberservice: SubscriberService,
    // private _auth: AuthService
    public dialog: MatDialog,
    private authFacade: AuthFacade,
    public authServ: AuthenticationService,
    private gatewayFacade: GatewayFacade,
    public gatewayService: GatewayService,

  ) {
    // tslint:disable-next-line: deprecation
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      this.activeMediaQuery = change
        ? `'${change.mqAlias}' = (${change.mediaQuery})`
        : '';
      if (change.mqAlias === 'sm' || change.mqAlias === 'xs') {
        this.opened = true;
        this.over = 'over';

        this._router.events.subscribe((event: Event) => {
          this.navigationInterceptor(event);
        });
      } else {
        this.opened = false;
        this.over = 'side';
      }
    });







    this._router.events.subscribe((event:  NavigationEnd ) => {

      //console.log('event ', event.url)
      if(event.url !== undefined)
      {

       if(event.url === "/home" || event.url=== "/" || event.url === "/login" || event.url === "/auth/login" || event.url === "/auth/login/login" || event.url === "/auth/manage" || event.url === "/subscribe" )
       {
         this.isHome = true;
         this.gatewayService.isHome$.next(true);
       }else{

         this.isHome = false;
         this.gatewayService.isHome$.next(false);

       }


      }





       })
  }
  SubscriberId = '';
  opened = false;
  over = 'side';
  expandHeight = '42px';
  collapseHeight = '42px';
  displayMode = 'flat';
  showprofile = false;
  // overlap = false;
  watcher: Subscription;
  activeMediaQuery = '';
  title = 'app';
  collapseTwo = false;
  @Input() sidenav: MatSidenav;
  //  @ViewChild('sideNav') sidenav: MatSidenav;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onClose = new EventEmitter<any>();
  payload: any;

  config = {
    paddingAtStart: true,
    interfaceWithRoute: true,
    classname: 'my-custom-class',
    // listBackgroundColor: `#141E30`,
    fontColor: `rgb(170, 170, 170)`,
    // backgroundColor: `#141E30`,
    selectedListFontColor: `white`,
    highlightOnSelect: true,
    collapseOnSelect: true,
    rtlLayout: false,
  };

  logOut() {
    this.authFacade.logOut()
//this.authServ.logout();
}

  private navigationInterceptor(event: Event): void {
    if (event instanceof NavigationStart) {
      // this._loadingBar.show();
    }
    if (event instanceof NavigationEnd) {
      // this._loadingBar.show();
    }
    if (event instanceof NavigationCancel) {
      // this._loadingBar.hide();
    }
    if (event instanceof NavigationError) {
      // this._loadingBar.hide();
    }
  }


  ngAfterViewInit() {
    //console.log("View init ", this.dashboard);
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnInit() {
    // this.spinner.show();
    // this.getSubscriber();


    if(this.authServ.getUser() != null)
    {
      this.user = this.authServ.getUser();
      this.gatewayService.isLoggedIn$.next(true);
      this.SubscriberName = this.user.SubscriberName;
      this.StaffName = this.user.StaffName;
    }else{
      this.gatewayService.isLoggedIn$.next(false);
    }

    //console.log("Login Staff", this.user,this.authServ.getUser());



    this.getAllRoles();

    // this.gatewayService.isLoggedIn$.subscribe((data) => {
    //   //console.log("Is Logged In ", data);
    // })

    // this.gatewayService.isHome$.subscribe((data) => {
    //   //console.log("Is Home ", data);
    // })


  }

  //   // notification dialog
  notificatonDialog(event: any) {
    //   const dialogRef = this.dialog.open(NotificationComponent, {
    //     data: event,
    // height: '1000',
    // width: '500'
    //   } );
    // // closed the dialog method
    //   dialogRef.afterClosed().subscribe(result => {
    //     });
  }

  messageDialog(event: any) {
    //   const dialogRef = this.dialog.open(MessageComponent, {
    //     data: event,
    // height: '1001',
    // width: '501'
    //   } );
    // // closed the dialog method
    //   dialogRef.afterClosed().subscribe(result => {
    //     });
  }

  getAllRoles(){
    this.gatewayFacade.loadGateway("Role").subscribe((data) => {
       this.rolesExistingInDB = data;

       ////console.log("Records gotten from Database ",this.rolesExistingInDB );

       let AllParents = this.rolesExistingInDB.filter(n => n.parentId === "");

       let roleParents: any[] = [];

        let singleParent: any = {};

       for(let roleparent of AllParents){

       singleParent.role = roleparent;
       singleParent.children = [];

        let rolechildren  = this.rolesExistingInDB.filter(n => n.parentId === roleparent.menuId);;
          for(let child of rolechildren)
          {
            let childMain: any = {};
             childMain.role = child;
             childMain.grandchildren = [];

             let rolegrandchildren = this.rolesExistingInDB.filter(n => n.parentId === child.menuId);
             //console.log("Grand Children ", rolegrandchildren);
             for(let grandchild of rolegrandchildren)
             {
              let grandchildMain: any = {};
              grandchildMain.role = grandchild;

              childMain.grandchildren.push(grandchildMain);
             }


           singleParent.children.push(childMain);
          }
          roleParents.push(singleParent);

       }


       //console.log("Transformed Data ", roleParents);


       if(this.user != null)
       {
        this.getAllStaffRole(this.user.Id);
       }


      // this.roles = roleParents;
       // Populate the Roles with

    })
  }




  getAllStaffRole(staffId: string){

    //console.log("Staff ID", staffId);
    this.gatewayFacade.genericFilterGateway("StaffRoleNew","StaffId", staffId)
    // .pipe(
    //   take()
    // )
    .subscribe((data) => {

      if(data.length > 0)
      {


      this.RoleForStaffData = data;
        localStorage.setItem('Link', JSON.stringify(data));
      // console.log("Staff Role In Data ", this.RoleForStaffData);

      this.selectedRolesForStaff = this.RoleForStaffData;


      this.RoleData = [];



      for( let role of this.rolesExistingInDB)
      {
        let staffRole: any = {};
        //Check if Menu exist in Staff Data

       // //console.log("Role Gotten ", role);

        let staffroleInData = this.RoleForStaffData.find(n => n.menuId === role.menuId)

        ////console.log("Role In Data ", staffroleInData);

        if(staffroleInData != undefined)
        {
          //staffRole = staffroleInData;
          staffRole.selected = true;
        }else{
          // staffRole.id = role.id;
          staffRole.selected = false;
        }

        staffRole.menuId = role.menuId;
        staffRole.name = role.name;
        staffRole.parentId = role.parentId;
        staffRole.subscriberId = this.user.SubscriberId;
        staffRole.siteId = this.user.siteId;
        staffRole.staffId = this.user.Id;
        staffRole.link = role.link;


        this.RoleData.push(staffRole);




      }

      //console.log("Transform StaffRole ", this.RoleData);

      let AllParents2 = this.RoleData.filter(n => n.parentId === "");


      let AllParents = AllParents2.sort(function(a, b) {
        var nameA = a.name; // ignore upper and lowercase
        var nameB = b.name; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });;

     // //console.log("All Parent ", AllParents);

      let roleParents: any[] = [];



      for(let roleparent of AllParents){
        let singleParent: any = {};
      singleParent.role = roleparent;
      singleParent.children = [];

      let staffroleInDataParent = this.RoleForStaffData.find(n => n.menuId === roleparent.menuId)
       if(!staffroleInDataParent)
       {
         continue;
       }

       let rolechildren  = this.RoleData.filter(n => n.parentId === roleparent.menuId).sort(function(a, b) {
        var nameA = a.name; // ignore upper and lowercase
        var nameB = b.name; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
         for(let child of rolechildren)
         {
           let childMain: any = {};
            childMain.role = child;
            childMain.grandchildren = [];

            let staffroleInDataChild = this.RoleForStaffData.find(n => n.menuId === child.menuId)
            if(!staffroleInDataChild)
            {
              continue;
            }

            let rolegrandchildren = this.RoleData.filter(n => n.parentId === child.menuId).sort(function(a, b) {
              var nameA = a.name; // ignore upper and lowercase
              var nameB = b.name; // ignore upper and lowercase
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }

              // names must be equal
              return 0;
            });
            //console.log("Grand Children ", rolegrandchildren);
            for(let grandchild of rolegrandchildren)
            {
             let grandchildMain: any = {};
             grandchildMain.role = grandchild;

             let staffroleInDataGrandChild = this.RoleForStaffData.find(n => n.menuId === grandchild.menuId)
             if(!staffroleInDataGrandChild)
             {
               continue;
             }

             childMain.grandchildren.push(grandchildMain);
            }


          singleParent.children.push(childMain);
         }
         roleParents.push(singleParent);

      }


      //console.log("Transformed Data ", roleParents);

      this.roles = roleParents;

      if (localStorage.getItem('AssignedRoles')) {
        localStorage.removeItem('AssignedRoles');
        localStorage.setItem('AssignedRoles', JSON.stringify(this.RoleForStaffData));
      }else{

        localStorage.setItem('AssignedRoles', JSON.stringify(this.RoleForStaffData));
      }


    }


      // Transform Here
    });
  }
}
